import _ from 'lodash';

export const getDashboard = state => _.get(state, 'internalStore.dashboard');
export const getIsError = state => _.get(getDashboard(state), 'isError');
export const getIsLoading = state => _.get(getDashboard(state), 'isLoading');
export const getIsLoadingMore = state => _.get(getDashboard(state), 'isLoadingMore');
export const getDateActivity = state => _.get(getDashboard(state), 'dateActivity');
export const getOrderBy = state => _.get(getDashboard(state), 'orderBy');
export const getOrderValue = state => _.get(getDashboard(state), 'orderValue');

export const getDashboardVersion = state =>
  _.get(state, 'internalStore.dashboard.dashboardVersion');
export const isDashboardSwitchIsVisible = state =>
  _.get(state, 'internalStore.dashboard.dashboardSwitchIsVisible');

export const getAreMapPeopleLoading = state =>
  _.get(state, 'internalStore.dashboard.areMapPeopleLoading');

export const getAreMapPropertiesLoading = state =>
  _.get(state, 'internalStore.dashboard.areMapPropertiesLoading');
